module.exports = __webpack_public_path__ + "img/phone.ca22dc16.svg";